/** 组织空间类型：个人空间 vs 协作团队空间。 */
export type OrganizationType = 'personal' | 'team';

/**
 * 从数据库字段或历史数据推断组织类型。
 * @param organizationType 显式类型字段
 * @param organizationCode 可选绑定的统一社会信用代码（不再用于区分空间类型）
 */
export function normalizeOrganizationType(
  organizationType: unknown,
  organizationCode = '',
): OrganizationType {
  if (organizationType === 'team' || organizationType === 'personal') {
    return organizationType;
  }
  return String(organizationCode ?? '').trim() ? 'team' : 'personal';
}

/** 是否为个人空间组织。 */
export function isPersonalOrganization(input: {
  organizationType?: OrganizationType;
  organizationCode?: string;
}): boolean {
  return normalizeOrganizationType(input.organizationType, input.organizationCode) === 'personal';
}

/** 是否为团队空间组织。 */
export function isTeamOrganization(input: {
  organizationType?: OrganizationType;
  organizationCode?: string;
}): boolean {
  return !isPersonalOrganization(input);
}

/**
 * 计费/授权使用的 scope 类型（内部仍沿用 enterprise 枚举值）。
 * @param organizationType 组织类型
 */
export function billingScopeTypeForOrganizationType(
  organizationType: OrganizationType,
): 'personal' | 'enterprise' {
  return organizationType === 'team' ? 'enterprise' : 'personal';
}
